import { CanActivateFn } from '@angular/router';
import { of } from 'rxjs';

import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { Store } from '@ngxs/store';
import { WwwAppState, WwwRouteSlug } from '@pro-connect/shared';
import { Navigate } from '@ngxs/router-plugin';

export const redirectToAccountIfLoggedInGuard: CanActivateFn = (route, state) => {
  const platformId = inject(PLATFORM_ID);
  const store = inject(Store);
  if (isPlatformServer(platformId)) {
    return of(true);
  }

  // it doesn't work because there is another domain for now
  // const jwtHp = document.cookie
  //   ?.split(';')
  //   ?.find((item) => item.includes('jwt_hp'))
  //   ?.split('=')[1];
  // if (!jwtHp) {
  //   store.dispatch(new WwwAppStateClearUserData());
  //   return of(true);
  // }

  const user = store.selectSnapshot(WwwAppState.user);
  console.warn('redirectToAccountIfLoggedInGuard', user);
  if (!user) {
    return of(true);
  }
  store.dispatch([new Navigate(['/', WwwRouteSlug.ACCOUNT])]);
  return of(false);
};
